import React, { useMemo, useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  CERTIFICATION_INDUSTRIES,
  CUSTOM_INDUSTRY_VALUE,
} from "@/data/certificationIndustries";

/**
 * Industry / field picker: choose from presets or enter a custom value.
 */
const IndustrySelect = ({ id, value = "", onChange, required = false }) => {
  const isPreset = CERTIFICATION_INDUSTRIES.includes(value);
  const [mode, setMode] = useState(
    !value ? "" : isPreset ? value : CUSTOM_INDUSTRY_VALUE
  );

  useEffect(() => {
    if (!value) {
      setMode("");
      return;
    }
    setMode(
      CERTIFICATION_INDUSTRIES.includes(value) ? value : CUSTOM_INDUSTRY_VALUE
    );
  }, [value]);

  const selectValue = useMemo(() => {
    if (!value && !mode) return undefined;
    if (mode === CUSTOM_INDUSTRY_VALUE) return CUSTOM_INDUSTRY_VALUE;
    if (CERTIFICATION_INDUSTRIES.includes(value)) return value;
    return mode || undefined;
  }, [value, mode]);

  const handleSelect = (next) => {
    if (next === CUSTOM_INDUSTRY_VALUE) {
      setMode(CUSTOM_INDUSTRY_VALUE);
      if (CERTIFICATION_INDUSTRIES.includes(value)) {
        onChange?.("");
      }
      return;
    }
    setMode(next);
    onChange?.(next);
  };

  return (
    <div className="space-y-2">
      <Select value={selectValue} onValueChange={handleSelect} required={required}>
        <SelectTrigger id={id} className="h-10 rounded-xl">
          <SelectValue placeholder="Select industry / field" />
        </SelectTrigger>
        <SelectContent>
          {CERTIFICATION_INDUSTRIES.map((industry) => (
            <SelectItem key={industry} value={industry}>
              {industry}
            </SelectItem>
          ))}
          <SelectItem value={CUSTOM_INDUSTRY_VALUE}>Other / Custom…</SelectItem>
        </SelectContent>
      </Select>

      {/* Native required guard when nothing selected */}
      <input
        tabIndex={-1}
        aria-hidden="true"
        className="sr-only"
        required={required}
        value={value || ""}
        onChange={() => {}}
      />

      {mode === CUSTOM_INDUSTRY_VALUE && (
        <Input
          value={
            CERTIFICATION_INDUSTRIES.includes(value) ? "" : value
          }
          onChange={(e) => onChange?.(e.target.value)}
          placeholder="Type custom industry / field"
          className="rounded-xl"
          required={required}
        />
      )}
    </div>
  );
};

export default IndustrySelect;
